import { render } from "./NotificationArea.vue?vue&type=template&id=9c114308&scoped=true"
import script from "./NotificationArea.vue?vue&type=script&lang=js"
export * from "./NotificationArea.vue?vue&type=script&lang=js"

import "./NotificationArea.vue?vue&type=style&index=0&id=9c114308&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c114308"]])

export default __exports__